import dayjs from "dayjs";
import duration, {type DurationUnitsObjectType} from "dayjs/plugin/duration";

dayjs.extend(duration);

export const getDurationFromInput = (input: string | number | DurationUnitsObjectType) =>
    dayjs.duration(input as DurationUnitsObjectType);
